export default "__VITE_ASSET__C$PdLJmf__"